<template>
  <div class="space-y-4">
    <div class="text-xl font-semibold">Measurements</div>
    <div class="mx-auto">
      <DButton severity="primary" class="w-full" size="small" @click="newMeasurement"
        ><div class="flex items-center justify-center gap-2 text-base">
          <Plus size="14" />
          <div>Create New</div>
        </div></DButton
      >
    </div>

    <div class="mt-4">
      <BookmarkItem
        v-for="measurement in filteredMeasurements"
        :key="measurement.id"
        :item="measurement"
        @contextmenu="showContext($event, measurement.code)"
        @click="handleClick(measurement)" />

      <div v-if="filteredMeasurements.length === 0" class="flex items-center justify-center text-gray-700">
        No Measurements
      </div>
    </div>
  </div>

  <DContextMenu2 ref="contextMenuRef" :model="contextItems" />
</template>
<script setup>
import { BookmarkItem } from '@/components';
import { useNodeManager } from '@/composables/useNodeManager';
import { useCruxModuleStore } from '@/stores/api/cruxmodules';
import { cameraControls, measurementHandler } from '@/threejs/core';
import { DButton, DContextMenu2, useConfirm, useToast } from '@disguise/cloud-ui';
import { Plus } from 'lucide-vue-next';
import { computed, ref } from 'vue';

const cruxModuleStore = useCruxModuleStore();
const currentId = ref(null);
const contextMenuRef = ref(null);

const { removeNode, findNodeById } = useNodeManager();

const { confirmDialog } = useConfirm();
const toast = useToast();

const filteredMeasurements = computed(() => {
  return cruxModuleStore.cruxModules.filter((module) => module.type === 'measurement') || [];
});

const newMeasurement = () => {
  if (measurementHandler) {
    measurementHandler.startMeasurement();
  }
};

const handleClick = (bookmark) => {
  updated({ data: bookmark });
};

const updated = (data) => {
  let bookmark = data.data;

  const centerPoint = {
    x: (bookmark.data.points[0].x + bookmark.data.points[1].x) / 2,
    y: (bookmark.data.points[0].y + bookmark.data.points[1].y) / 2,
    z: (bookmark.data.points[0].z + bookmark.data.points[1].z) / 2,
  };

  cameraControls.setTarget(centerPoint.x, centerPoint.y, centerPoint.z, true);
};

const editMeasurement = () => {
  measurementHandler.highLightMeasurement(currentId.value);
};

const contextItems = ref([
  {
    label: 'Edit',
    icon: 'pi pi-pencil',
    command: () => {
      editMeasurement();
    },
  },
  {
    label: 'Delete',
    icon: 'pi pi-trash',
    command: () => {
      confirmDialog('Confirmation', 'Are you sure you want to delete this measurement?', 'Delete', 'Cancel')
        .then((response) => {
          if (response) {
            return removeNode(currentId.value);
          }
        })
        .catch((err) => {
          console.error('Error deleting measurement:', err);
          toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to delete measurement',
            group: 'br',
            life: 5000,
          });
        });
    },
  },
]);

const showContext = ($event, Id) => {
  currentId.value = Id;
  contextMenuRef.value.show($event);
};
</script>
